<template>
  <avue-empty :size="40"></avue-empty>
</template>

<script>
export default {
  name: 'empty'
};
</script>

<style lang="scss" scoped>
.avue-empty {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: 0;

  & /deep/ .avue-empty__image {
    display: none;
  }

  & /deep/ .avue-empty__desc {
    font-size: 14px;
    color: #ccc;
  }
}
</style>
